import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { logoUrl } = useTheme();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      toast.success('Login realizado com sucesso!');
      if (data.user.role === 'visualizador') {
        navigate('/reports');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      toast.error('Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-start px-8 md:px-32 relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: 'url(/login-bg.png)',
          filter: 'brightness(0.3)' 
        }}
      />
      <div className="absolute inset-0 bg-noise" />
      
      <Card className="w-full max-w-md p-8 bg-card/90 backdrop-blur-xl border-2 border-border relative z-10" data-testid="login-card">
        <div className="text-center mb-8">
          <p className="text-muted-foreground text-sm tracking-wide font-bold uppercase mb-4">Sistema de Controle</p>
          {logoUrl ? (
            <img 
              src={logoUrl} 
              alt="Logo" 
              className="h-24 mx-auto object-contain mb-4 drop-shadow-[0_0_20px_rgba(250,204,21,0.6)]" 
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          ) : (
            <h1 className="text-5xl font-extrabold uppercase tracking-tight bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 bg-clip-text text-transparent drop-shadow-[0_0_12px_rgba(250,204,21,0.8)] mb-2" data-testid="login-title">
              Bar Cabrones
            </h1>
          )}
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
            <Input
              id="email"
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 bg-input border-transparent focus:border-primary font-mono"
              required
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-wider text-muted-foreground">Senha</Label>
            <Input
              id="password"
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-input border-transparent focus:border-primary font-mono"
              required
            />
          </div>
          <Button 
            type="submit" 
            data-testid="login-submit-button"
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase tracking-wider h-12"
            disabled={loading}
          >
            {loading ? 'Acessando...' : 'Entrar no Sistema'}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default Login;
